class DialogDemo extends React.Component {
  constructor() {
    super();

    this.state = {
      isDialogOpen: [false, false]
    };
    this.openDialog = this.openDialog.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  openDialog(dialog) {
    let isDialogOpen = this.state.isDialogOpen;
    isDialogOpen[dialog] = true;
    this.setState({isDialogOpen})
  }

  confirmDialog(dialog) {
    alert(`Dialog ${dialog} has been confirmed`);
    this.closeDialog(dialog);
  }

  closeDialog(dialog) {
    let isDialogOpen = this.state.isDialogOpen;
    isDialogOpen[dialog] = false;
    this.setState({isDialogOpen})
  }

  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="dialog">
          Dialog
          <span className="section__item-docs">
            Documentation:&nbsp;
            <a href="docs/components/class/components/Dialog.jsx~Dialog.html" target="_blank">JS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Dialogs</h4>
              <div className="demo__code">
                <CodeBlock lang="jsx">
                {`
@import {Dialog, Modal} from 'airtame-gooey';

...

constructor {
  super();

  this.state = {
    isDialogOpen: [false, false]
  };
  this.openDialog = this.openDialog.bind(this);
  this.confirmDialog = this.confirmDialog.bind(this);
  this.closeDialog = this.closeDialog.bind(this);
}

openDialog(dialog) {
  let isDialogOpen = this.state.isDialogOpen;
  isDialogOpen[dialog] = true;
  this.setState({isDialogOpen})
}

confirmDialog(dialog) {
  alert(\`Dialog $\{dialog} has been confirmed\`);
  this.closeDialog(dialog);
}

closeDialog(dialog) {
  let isDialogOpen = this.state.isDialogOpen;
  isDialogOpen[dialog] = false;
  this.setState({isDialogOpen})
}

...

render() {
  return(
    <div className="dialog-demo">
      <button onClick={() => {this.openDialog(0)}}>Dialog 1</button>
      <Dialog isOpen={this.state.isDialogOpen[0]}
             onConfirm={() => {this.confirmDialog(0)}}
             onCancel={() => {this.closeDialog(0)}}
             className="dialog1">
        <h2>This is my first dialog</h2>
      </Dialog>
      <button onClick={() => {this.openDialog(1)}}>Dialog 2</button>
      <Dialog isOpen={this.state.isDialogOpen[1]}
             onConfirm={() => {this.confirmDialog(1)}}
             onClose={() => {this.closeDialog(1)}}
             className="dialog2">
        <h2>This is my second dialog</h2>
      </Dialog>
    </div>
  )
}
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.dialog-demo {
  .dialog {
    @include modal();
    @include dialog();
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="dialog-demo">
                    <button onClick={() => {this.openDialog(0)}}>Dialog 1</button>
                    <Dialog isOpen={this.state.isDialogOpen[0]}
                           onConfirm={() => {this.confirmDialog(0)}}
                           onCancel={() => {this.closeDialog(0)}}
                           className="dialog1">
                      <h2>This is my first dialog</h2>
                    </Dialog>
                    <button onClick={() => {this.openDialog(1)}}>Dialog 2</button>
                    <Dialog isOpen={this.state.isDialogOpen[1]}
                           onConfirm={() => {this.confirmDialog(1)}}
                           onCancel={() => {this.closeDialog(1)}}
                           className="dialog2">
                      <h2>This is my second dialog</h2>
                    </Dialog>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
